import {SportList} from "../models/ISport";

export type CountriesList = Record<string, {
    'ru_name': string,
    'svg_url': string
}>

export const COUNTRIES: CountriesList = {
    // 'wcfut': {
    //     'ru_name': 'Чемпионат мира',
    //     'svg_url': 'https://upload.wikimedia.org/wikipedia/ru/e/e3/2022_FIFA_World_Cup.svg'
    // },
    'wcfut': {
        'ru_name': '',
        'svg_url': 'https://www.svgrepo.com/show/275957/planet-earth-global.svg'
    },
    'Euro 2024 Qualifying': {
        'ru_name': '',
        'svg_url': 'https://upload.wikimedia.org/wikipedia/commons/thumb/archive/6/6c/20220510234650%21UEFA_Euro_2024_logo.svg/120px-UEFA_Euro_2024_logo.svg.png'
        // 'svg_url': 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/UEFA_Euro_2024_logo.svg/416px-UEFA_Euro_2024_logo.svg.png'
    },
    'Международный матч': {
        'ru_name': '',
        'svg_url': 'https://www.svgrepo.com/show/275957/planet-earth-global.svg'
    },
    'all':
        {
            'ru_name': 'Все',
            'svg_url': ''
        },
    'ad':
        {
            'ru_name': 'Андорра',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ad.svg'
        },
    'ae':
        {
            'ru_name': 'Объединенные Арабские Эмираты',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ae.svg'
        },
    'af':
        {
            'ru_name': 'Афганистан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/af.svg'
        },
    'ag':
        {
            'ru_name': 'Антигуа и Барбуда',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ag.svg'
        },
    'ai':
        {
            'ru_name': 'Ангилья',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ai.svg'
        },
    'al':
        {
            'ru_name': 'Албания',
            'svg_url': 'https://spoyer.ru/api/icons/countries/al.svg'
        },
    'am':
        {
            'ru_name': 'Армения',
            'svg_url': 'https://spoyer.ru/api/icons/countries/am.svg'
        },
    'ao':
        {
            'ru_name': 'Ангола',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ao.svg'
        },
    'aq':
        {
            'ru_name': 'Антарктида',
            'svg_url': 'https://spoyer.ru/api/icons/countries/aq.svg'
        },
    'ar':
        {
            'ru_name': 'Аргентина',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ar.svg'
        },
    'as':
        {
            'ru_name': 'Американское Самоа',
            'svg_url': 'https://spoyer.ru/api/icons/countries/as.svg'
        },
    'at':
        {
            'ru_name': 'Австрия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/at.svg'
        },
    'au':
        {
            'ru_name': 'Австралия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/au.svg'
        },
    'aw':
        {
            'ru_name': 'Аруба',
            'svg_url': 'https://spoyer.ru/api/icons/countries/aw.svg'
        },
    'az':
        {
            'ru_name': 'Азербайджан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/az.svg'
        },
    'ba':
        {
            'ru_name': 'Босния и Герцеговина',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ba.svg'
        },
    'bb':
        {
            'ru_name': 'Барбадос',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bb.svg'
        },
    'bd':
        {
            'ru_name': 'Бангладеш',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bd.svg'
        },
    'be':
        {
            'ru_name': 'Бельгия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/be.svg'
        },
    'bf':
        {
            'ru_name': 'Буркина-Фасо',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bf.svg'
        },
    'bg':
        {
            'ru_name': 'Болгария',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bg.svg'
        },
    'bh':
        {
            'ru_name': 'Бахрейн',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bh.svg'
        },
    'bi':
        {
            'ru_name': 'Бурунди',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bi.svg'
        },
    'bj':
        {
            'ru_name': 'Бенин',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bj.svg'
        },
    'bl':
        {
            'ru_name': 'Сен-Бартс',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bl.svg'
        },
    'bm':
        {
            'ru_name': 'Бермуды',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bm.svg'
        },
    'bn':
        {
            'ru_name': 'Бруней',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bn.svg'
        },
    'bo':
        {
            'ru_name': 'Боливия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bo.svg'
        },
    'bq':
        {
            'ru_name': 'Карибские Нидерланды',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bq.svg'
        },
    'br':
        {
            'ru_name': 'Бразилия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/br.svg'
        },
    'bs':
        {
            'ru_name': 'Багамы',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bs.svg'
        },
    'bt':
        {
            'ru_name': 'Бутан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bt.svg'
        },
    'bv':
        {
            'ru_name': 'Остров Буве',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bv.svg'
        },
    'bw':
        {
            'ru_name': 'Ботсвана',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bw.svg'
        },
    'by':
        {
            'ru_name': 'Беларусь',
            'svg_url': 'https://spoyer.ru/api/icons/countries/by.svg'
        },
    'bz':
        {
            'ru_name': 'Белиз',
            'svg_url': 'https://spoyer.ru/api/icons/countries/bz.svg'
        },
    'ca':
        {
            'ru_name': 'Канада',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ca.svg'
        },
    'cc':
        {
            'ru_name': 'Кокосовые острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cc.svg'
        },
    'cd':
        {
            'ru_name': 'Конго - Киншаса',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cd.svg'
        },
    'cf':
        {
            'ru_name': 'Центрально-Африканская Республика',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cf.svg'
        },
    'cg':
        {
            'ru_name': 'Конго - Браззавиль',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cg.svg'
        },
    'ch':
        {
            'ru_name': 'Швейцария',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ch.svg'
        },
    'ck':
        {
            'ru_name': 'Острова Кука',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ck.svg'
        },
    'cl':
        {
            'ru_name': 'Чили',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cl.svg'
        },
    'cm':
        {
            'ru_name': 'Камерун',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cm.svg'
        },
    'cn':
        {
            'ru_name': 'Китай',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cn.svg'
        },
    'co':
        {
            'ru_name': 'Колумбия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/co.svg'
        },
    'cr':
        {
            'ru_name': 'Коста-Рика',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cr.svg'
        },
    'cu':
        {
            'ru_name': 'Куба',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cu.svg'
        },
    'cv':
        {
            'ru_name': 'Кабо-Верде',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cv.svg'
        },
    'cx':
        {
            'ru_name': 'Остров Рождества',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cx.svg'
        },
    'cy':
        {
            'ru_name': 'Кипр',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cy.svg'
        },
    'cz':
        {
            'ru_name': 'Республика Чехия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/cz.svg'
        },
    'de':
        {
            'ru_name': 'Германия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/de.svg'
        },
    'dj':
        {
            'ru_name': 'Джибути',
            'svg_url': 'https://spoyer.ru/api/icons/countries/dj.svg'
        },
    'dk':
        {
            'ru_name': 'Дания',
            'svg_url': 'https://spoyer.ru/api/icons/countries/dk.svg'
        },
    'dm':
        {
            'ru_name': 'Доминика',
            'svg_url': 'https://spoyer.ru/api/icons/countries/dm.svg'
        },
    'do':
        {
            'ru_name': 'Доминиканская Респблика',
            'svg_url': 'https://spoyer.ru/api/icons/countries/do.svg'
        },
    'dz':
        {
            'ru_name': 'Алжир',
            'svg_url': 'https://spoyer.ru/api/icons/countries/dz.svg'
        },
    'ec':
        {
            'ru_name': 'Эквадор',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ec.svg'
        },
    'ee':
        {
            'ru_name': 'Эстония',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ee.svg'
        },
    'eg':
        {
            'ru_name': 'Египет',
            'svg_url': 'https://spoyer.ru/api/icons/countries/eg.svg'
        },
    'eh':
        {
            'ru_name': 'Западная Сахара',
            'svg_url': 'https://spoyer.ru/api/icons/countries/eh.svg'
        },
    'er':
        {
            'ru_name': 'Эритрея',
            'svg_url': 'https://spoyer.ru/api/icons/countries/er.svg'
        },
    'es':
        {
            'ru_name': 'Испания',
            'svg_url': 'https://spoyer.ru/api/icons/countries/es.svg'
        },
    'et':
        {
            'ru_name': 'Эфиопия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/et.svg'
        },
    'eu': {
        'ru_name': 'Европа',
        'svg_url': 'https://spoyer.ru/api/icons/countries/eu.svg'
    },
    'fi':
        {
            'ru_name': 'Финляндия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/fi.svg'
        },
    'fj':
        {
            'ru_name': 'Фиджи',
            'svg_url': 'https://spoyer.ru/api/icons/countries/fj.svg'
        },
    'fk':
        {
            'ru_name': 'Фолклендские острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/fk.svg'
        },
    'fm':
        {
            'ru_name': 'Микронезия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/fm.svg'
        },
    'fo':
        {
            'ru_name': 'Фарерские острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/fo.svg'
        },
    'fr':
        {
            'ru_name': 'Франция',
            'svg_url': 'https://spoyer.ru/api/icons/countries/fr.svg'
        },
    'ga':
        {
            'ru_name': 'Габон',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ga.svg'
        },
    'gb':
        {
            'ru_name': 'Великобритания',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gb.svg'
        },
    'gd':
        {
            'ru_name': 'Гренада',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gd.svg'
        },
    'ge':
        {
            'ru_name': 'Грузия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ge.svg'
        },
    'gf':
        {
            'ru_name': 'Французская Гвиана',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gf.svg'
        },
    'gg':
        {
            'ru_name': 'Гернси',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gg.svg'
        },
    'gh':
        {
            'ru_name': 'Гана',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gh.svg'
        },
    'gi':
        {
            'ru_name': 'Гибралтар',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gi.svg'
        },
    'gl':
        {
            'ru_name': 'Гренландия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gl.svg'
        },
    'gm':
        {
            'ru_name': 'Гамбия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gm.svg'
        },
    'gn':
        {
            'ru_name': 'Гвинея',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gn.svg'
        },
    'gp':
        {
            'ru_name': 'Гваделупа',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gp.svg'
        },
    'gq':
        {
            'ru_name': 'Экваториальная Гвинея',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gq.svg'
        },
    'gr':
        {
            'ru_name': 'Греция',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gr.svg'
        },
    'gs':
        {
            'ru_name': 'Южная Георгия и Южные Сандвичевы острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gs.svg'
        },
    'gt':
        {
            'ru_name': 'Гватемала',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gt.svg'
        },
    'gu':
        {
            'ru_name': 'Гуам',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gu.svg'
        },
    'gw':
        {
            'ru_name': 'Гвинея-Бисау',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gw.svg'
        },
    'gy':
        {
            'ru_name': 'Гайана',
            'svg_url': 'https://spoyer.ru/api/icons/countries/gy.svg'
        },
    'hk':
        {
            'ru_name': 'Гонконг (САР Китай)',
            'svg_url': 'https://spoyer.ru/api/icons/countries/hk.svg'
        },
    'hm':
        {
            'ru_name': 'Острова Херд и Макдональд',
            'svg_url': 'https://spoyer.ru/api/icons/countries/hm.svg'
        },
    'hn':
        {
            'ru_name': 'Гондурас',
            'svg_url': 'https://spoyer.ru/api/icons/countries/hn.svg'
        },
    'hr':
        {
            'ru_name': 'Хорватия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/hr.svg'
        },
    'ht':
        {
            'ru_name': 'Гаити',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ht.svg'
        },
    'hu':
        {
            'ru_name': 'Венгрия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/hu.svg'
        },
    'id':
        {
            'ru_name': 'Индонезия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/id.svg'
        },
    'ie':
        {
            'ru_name': 'Ирландия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ie.svg'
        },
    'il':
        {
            'ru_name': 'Израиль',
            'svg_url': 'https://spoyer.ru/api/icons/countries/il.svg'
        },
    'im':
        {
            'ru_name': 'Остров Мэн',
            'svg_url': 'https://spoyer.ru/api/icons/countries/im.svg'
        },
    'in':
        {
            'ru_name': 'Индия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/in.svg'
        },
    'io':
        {
            'ru_name': 'Британская территория Индийского океана',
            'svg_url': 'https://spoyer.ru/api/icons/countries/io.svg'
        },
    'iq':
        {
            'ru_name': 'Ирак',
            'svg_url': 'https://spoyer.ru/api/icons/countries/iq.svg'
        },
    'ir':
        {
            'ru_name': 'Иран',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ir.svg'
        },
    'is':
        {
            'ru_name': 'Исландия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/is.svg'
        },
    'it':
        {
            'ru_name': 'Италия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/it.svg'
        },
    'je':
        {
            'ru_name': 'Джерси',
            'svg_url': 'https://spoyer.ru/api/icons/countries/je.svg'
        },
    'jm':
        {
            'ru_name': 'Ямайка',
            'svg_url': 'https://spoyer.ru/api/icons/countries/jm.svg'
        },
    'jo':
        {
            'ru_name': 'Иордания',
            'svg_url': 'https://spoyer.ru/api/icons/countries/jo.svg'
        },
    'jp':
        {
            'ru_name': 'Япония',
            'svg_url': 'https://spoyer.ru/api/icons/countries/jp.svg'
        },
    'ke':
        {
            'ru_name': 'Кения',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ke.svg'
        },
    'kg':
        {
            'ru_name': 'Кыргызстан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/kg.svg'
        },
    'kh':
        {
            'ru_name': 'Камбоджа',
            'svg_url': 'https://spoyer.ru/api/icons/countries/kh.svg'
        },
    'ki':
        {
            'ru_name': 'Кирибати',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ki.svg'
        },
    'km':
        {
            'ru_name': 'Коморские острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/km.svg'
        },
    'kn':
        {
            'ru_name': 'Сент-Китс и Невис',
            'svg_url': 'https://spoyer.ru/api/icons/countries/kn.svg'
        },
    'kp':
        {
            'ru_name': 'Северная Корея',
            'svg_url': 'https://spoyer.ru/api/icons/countries/kp.svg'
        },
    'kr':
        {
            'ru_name': 'Южная Корея',
            'svg_url': 'https://spoyer.ru/api/icons/countries/kr.svg'
        },
    'kw':
        {
            'ru_name': 'Кувейт',
            'svg_url': 'https://spoyer.ru/api/icons/countries/kw.svg'
        },
    'ky':
        {
            'ru_name': 'Каймановы острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ky.svg'
        },
    'kz':
        {
            'ru_name': 'Казахстан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/kz.svg'
        },
    'la':
        {
            'ru_name': 'Лаос',
            'svg_url': 'https://spoyer.ru/api/icons/countries/la.svg'
        },
    'lb':
        {
            'ru_name': 'Ливан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/lb.svg'
        },
    'lc':
        {
            'ru_name': 'Санкт-Люсия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/lc.svg'
        },
    'li':
        {
            'ru_name': 'Лихтенштейн',
            'svg_url': 'https://spoyer.ru/api/icons/countries/li.svg'
        },
    'lk':
        {
            'ru_name': 'Шри-Ланка',
            'svg_url': 'https://spoyer.ru/api/icons/countries/lk.svg'
        },
    'lr':
        {
            'ru_name': 'Либерия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/lr.svg'
        },
    'ls':
        {
            'ru_name': 'Лесото',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ls.svg'
        },
    'lt':
        {
            'ru_name': 'Литва',
            'svg_url': 'https://spoyer.ru/api/icons/countries/lt.svg'
        },
    'lu':
        {
            'ru_name': 'Люксембург',
            'svg_url': 'https://spoyer.ru/api/icons/countries/lu.svg'
        },
    'lv':
        {
            'ru_name': 'Латвия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/lv.svg'
        },
    'ly':
        {
            'ru_name': 'Ливия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ly.svg'
        },
    'ma':
        {
            'ru_name': 'Марокко',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ma.svg'
        },
    'mc':
        {
            'ru_name': 'Монако',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mc.svg'
        },
    'md':
        {
            'ru_name': 'Молдова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/md.svg'
        },
    'me':
        {
            'ru_name': 'Черногория',
            'svg_url': 'https://spoyer.ru/api/icons/countries/me.svg'
        },
    'mf':
        {
            'ru_name': 'Сен-Мартен',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mf.svg'
        },
    'mg':
        {
            'ru_name': 'Мадагаскар',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mg.svg'
        },
    'mh':
        {
            'ru_name': 'Маршалловы острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mh.svg'
        },
    'mk':
        {
            'ru_name': 'Македония',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mk.svg'
        },
    'ml':
        {
            'ru_name': 'Мали',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ml.svg'
        },
    'mm':
        {
            'ru_name': 'Мьянма (Бирма)',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mm.svg'
        },
    'mn':
        {
            'ru_name': 'Монголия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mn.svg'
        },
    'mo':
        {
            'ru_name': 'Макао САР Китай',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mo.svg'
        },
    'mp':
        {
            'ru_name': 'Северные Марианские острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mp.svg'
        },
    'mq':
        {
            'ru_name': 'Мартиника',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mq.svg'
        },
    'mr':
        {
            'ru_name': 'Мавритания',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mr.svg'
        },
    'ms':
        {
            'ru_name': 'Монсеррат',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ms.svg'
        },
    'mt':
        {
            'ru_name': 'Мальта',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mt.svg'
        },
    'mu':
        {
            'ru_name': 'Маврикий',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mu.svg'
        },
    'mv':
        {
            'ru_name': 'Мальдивы',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mv.svg'
        },
    'mw':
        {
            'ru_name': 'Малави',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mw.svg'
        },
    'mx':
        {
            'ru_name': 'Мексика',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mx.svg'
        },
    'my':
        {
            'ru_name': 'Малайзия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/my.svg'
        },
    'mz':
        {
            'ru_name': 'Мозамбик',
            'svg_url': 'https://spoyer.ru/api/icons/countries/mz.svg'
        },
    'na':
        {
            'ru_name': 'Намибия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/na.svg'
        },
    'nc':
        {
            'ru_name': 'Новая Каледония',
            'svg_url': 'https://spoyer.ru/api/icons/countries/nc.svg'
        },
    'ne':
        {
            'ru_name': 'Нигер',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ne.svg'
        },
    'nf':
        {
            'ru_name': 'Остров Норфолк',
            'svg_url': 'https://spoyer.ru/api/icons/countries/nf.svg'
        },
    'ng':
        {
            'ru_name': 'Нигерия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ng.svg'
        },
    'ni':
        {
            'ru_name': 'Никарагуа',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ni.svg'
        },
    'nl':
        {
            'ru_name': 'Нидерланды',
            'svg_url': 'https://spoyer.ru/api/icons/countries/nl.svg'
        },
    'no':
        {
            'ru_name': 'Норвегия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/no.svg'
        },
    'np':
        {
            'ru_name': 'Непал',
            'svg_url': 'https://spoyer.ru/api/icons/countries/np.svg'
        },
    'nr':
        {
            'ru_name': 'Науру',
            'svg_url': 'https://spoyer.ru/api/icons/countries/nr.svg'
        },
    'nu':
        {
            'ru_name': 'Ниуэ',
            'svg_url': 'https://spoyer.ru/api/icons/countries/nu.svg'
        },
    'nz':
        {
            'ru_name': 'Новая Зеландия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/nz.svg'
        },
    'om':
        {
            'ru_name': 'Оман',
            'svg_url': 'https://spoyer.ru/api/icons/countries/om.svg'
        },
    'pa':
        {
            'ru_name': 'Панама',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pa.svg'
        },
    'pe':
        {
            'ru_name': 'Перу',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pe.svg'
        },
    'pf':
        {
            'ru_name': 'Французская Полинезия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pf.svg'
        },
    'pg':
        {
            'ru_name': 'Папуа - Новая Гвинея',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pg.svg'
        },
    'ph':
        {
            'ru_name': 'Филиппины',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ph.svg'
        },
    'pk':
        {
            'ru_name': 'Пакистан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pk.svg'
        },
    'pl':
        {
            'ru_name': 'Польша',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pl.svg'
        },
    'pm':
        {
            'ru_name': 'Сен-Пьер и Микелон',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pm.svg'
        },
    'pn':
        {
            'ru_name': 'Острова Питкэрн',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pn.svg'
        },
    'pr':
        {
            'ru_name': 'Пуэрто-Рико',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pr.svg'
        },
    'ps':
        {
            'ru_name': 'территории Палестины',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ps.svg'
        },
    'pt':
        {
            'ru_name': 'Португалия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pt.svg'
        },
    'pw':
        {
            'ru_name': 'Палау',
            'svg_url': 'https://spoyer.ru/api/icons/countries/pw.svg'
        },
    'py':
        {
            'ru_name': 'Парагвай',
            'svg_url': 'https://spoyer.ru/api/icons/countries/py.svg'
        },
    'qa':
        {
            'ru_name': 'Катар',
            'svg_url': 'https://spoyer.ru/api/icons/countries/qa.svg'
        },
    'ro':
        {
            'ru_name': 'Румыния',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ro.svg'
        },
    'rs':
        {
            'ru_name': 'Сербия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/rs.svg'
        },
    'ru':
        {
            'ru_name': 'Россия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ru.svg'
        },
    'rw':
        {
            'ru_name': 'Руанда',
            'svg_url': 'https://spoyer.ru/api/icons/countries/rw.svg'
        },
    'sa':
        {
            'ru_name': 'Саудовская Аравия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sa.svg'
        },
    'sb':
        {
            'ru_name': 'Соломоновы острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sb.svg'
        },
    'sc':
        {
            'ru_name': 'Сейшельские острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sc.svg'
        },
    'sd':
        {
            'ru_name': 'Судан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sd.svg'
        },
    'se':
        {
            'ru_name': 'Швеция',
            'svg_url': 'https://spoyer.ru/api/icons/countries/se.svg'
        },
    'sg':
        {
            'ru_name': 'Сингапур',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sg.svg'
        },
    'sh':
        {
            'ru_name': 'Остров Святой Елены',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sh.svg'
        },
    'si':
        {
            'ru_name': 'Словения',
            'svg_url': 'https://spoyer.ru/api/icons/countries/si.svg'
        },
    'sj':
        {
            'ru_name': 'Шпицберген и Ян Майен',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sj.svg'
        },
    'sk':
        {
            'ru_name': 'Словакия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sk.svg'
        },
    'sl':
        {
            'ru_name': 'Сьерра-Леоне',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sl.svg'
        },
    'sm':
        {
            'ru_name': 'Сан-Марино',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sm.svg'
        },
    'sn':
        {
            'ru_name': 'Сенегал',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sn.svg'
        },
    'so':
        {
            'ru_name': 'Сомали',
            'svg_url': 'https://spoyer.ru/api/icons/countries/so.svg'
        },
    'sr':
        {
            'ru_name': 'Суринам',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sr.svg'
        },
    'ss':
        {
            'ru_name': 'Южный Судан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ss.svg'
        },
    'sv':
        {
            'ru_name': 'Сальвадор',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sv.svg'
        },
    'sx':
        {
            'ru_name': 'Синт-Мартен',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sx.svg'
        },
    'sy':
        {
            'ru_name': 'Сирия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sy.svg'
        },
    'sz':
        {
            'ru_name': 'Свазиленд',
            'svg_url': 'https://spoyer.ru/api/icons/countries/sz.svg'
        },
    'tc':
        {
            'ru_name': 'Острова Теркс и Кайкос',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tc.svg'
        },
    'td':
        {
            'ru_name': 'Чад',
            'svg_url': 'https://spoyer.ru/api/icons/countries/td.svg'
        },
    'tf':
        {
            'ru_name': 'Южные Французские Территории',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tf.svg'
        },
    'tg':
        {
            'ru_name': 'Того',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tg.svg'
        },
    'th':
        {
            'ru_name': 'Таиланд',
            'svg_url': 'https://spoyer.ru/api/icons/countries/th.svg'
        },
    'tj':
        {
            'ru_name': 'Таджикистан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tj.svg'
        },
    'tk':
        {
            'ru_name': 'Токелау',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tk.svg'
        },
    'tl':
        {
            'ru_name': 'Тимор-Лешти',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tl.svg'
        },
    'tm':
        {
            'ru_name': 'Туркменистан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tm.svg'
        },
    'tn':
        {
            'ru_name': 'Тунис',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tn.svg'
        },
    'to':
        {
            'ru_name': 'Тонга',
            'svg_url': 'https://spoyer.ru/api/icons/countries/to.svg'
        },
    'tr':
        {
            'ru_name': 'Турция',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tr.svg'
        },
    'tt':
        {
            'ru_name': 'Тринидад и Тобаго',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tt.svg'
        },
    'tv':
        {
            'ru_name': 'Тувалу',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tv.svg'
        },
    'tw':
        {
            'ru_name': 'Тайвань',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tw.svg'
        },
    'tz':
        {
            'ru_name': 'Танзания',
            'svg_url': 'https://spoyer.ru/api/icons/countries/tz.svg'
        },
    'ua':
        {
            'ru_name': 'Украина',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ua.svg'
        },
    'ug':
        {
            'ru_name': 'Уганда',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ug.svg'
        },
    'um':
        {
            'ru_name': 'Внешние острова США',
            'svg_url': 'https://spoyer.ru/api/icons/countries/um.svg'
        },
    'us':
        {
            'ru_name': 'США',
            'svg_url': 'https://spoyer.ru/api/icons/countries/us.svg'
        },
    'uy':
        {
            'ru_name': 'Уругвай',
            'svg_url': 'https://spoyer.ru/api/icons/countries/uy.svg'
        },
    'uz':
        {
            'ru_name': 'Узбекистан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/uz.svg'
        },
    'va':
        {
            'ru_name': 'Ватикан',
            'svg_url': 'https://spoyer.ru/api/icons/countries/va.svg'
        },
    'vc':
        {
            'ru_name': 'Сент-Винсент и Гренадины',
            'svg_url': 'https://spoyer.ru/api/icons/countries/vc.svg'
        },
    've':
        {
            'ru_name': 'Венесуэла',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ve.svg'
        },
    'vg':
        {
            'ru_name': 'Британские Виргинские острова',
            'svg_url': 'https://spoyer.ru/api/icons/countries/vg.svg'
        },
    'vi':
        {
            'ru_name': 'Виргинские острова США',
            'svg_url': 'https://spoyer.ru/api/icons/countries/vi.svg'
        },
    'vn':
        {
            'ru_name': 'Вьетнам',
            'svg_url': 'https://spoyer.ru/api/icons/countries/vn.svg'
        },
    'vu':
        {
            'ru_name': 'Вануату',
            'svg_url': 'https://spoyer.ru/api/icons/countries/vu.svg'
        },
    'wf':
        {
            'ru_name': 'Уоллис и Футуна',
            'svg_url': 'https://spoyer.ru/api/icons/countries/wf.svg'
        },
    'ws':
        {
            'ru_name': 'Самоа',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ws.svg'
        },
    'ye':
        {
            'ru_name': 'Йемен',
            'svg_url': 'https://spoyer.ru/api/icons/countries/ye.svg'
        },
    'yt':
        {
            'ru_name': 'Майотта',
            'svg_url': 'https://spoyer.ru/api/icons/countries/yt.svg'
        },
    'za':
        {
            'ru_name': 'Южная Африка',
            'svg_url': 'https://spoyer.ru/api/icons/countries/za.svg'
        },
    'zm':
        {
            'ru_name': 'Замбия',
            'svg_url': 'https://spoyer.ru/api/icons/countries/zm.svg'
        },
    'zw':
        {
            'ru_name': 'Зимбабве',
            'svg_url': 'https://spoyer.ru/api/icons/countries/zw.svg'
        }
}


export const SPORTS: SportList = {
    'all': {'count': 19, 'ru_name': 'Все'},
    'basketball': {'count': 4, 'ru_name': 'Баскетбол'},
    'icehockey': {'count': 15, 'ru_name': 'Хоккей'},
    'soccer': {'count': 15, 'ru_name': 'Футбол'}
}
